import styled from "@emotion/styled";
import { Box } from "@mui/material";

export const GroupHeaderTabsStyles = styled(Box)`
  width: 100%;
`;

export const TabsContainer = styled(Box)`
  border-bottom: 1px;
  border-color: divider;
`;
